import { useInfiniteQuery } from '@tanstack/react-query'
import { useCompanyDataServiceV2 } from '../api'
import { useEffect } from 'react'

const COMPANIES_QUERY_KEY = 'companies'
const PAGE_SIZE = 50
const MINIMUM_SEARCH_STRING_LENGTH = 2

export const useCompanyData = (searchString: string = '') => {
  const companyDataV2 = useCompanyDataServiceV2()

  const searchParam =
    searchString.length > MINIMUM_SEARCH_STRING_LENGTH
      ? searchString
      : undefined

  const fetchCompanies = ({ pageParam = 0 }) =>
    companyDataV2.getCompanies(
      pageParam,
      PAGE_SIZE,
      undefined,
      undefined,
      searchParam
    )

  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useInfiniteQuery({
      queryKey: [COMPANIES_QUERY_KEY, searchParam],
      queryFn: fetchCompanies,
      getNextPageParam: (lastPage, allPages) =>
        lastPage.length === PAGE_SIZE ? allPages.length : undefined,
      initialPageParam: 0,
    })

  useEffect(() => {
    if (!isLoading && hasNextPage && !isFetchingNextPage) {
      fetchNextPage()
    }
  }, [isLoading, hasNextPage, fetchNextPage, isFetchingNextPage])

  return {
    data: data?.pages.flat(),
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  }
}
